import { makeAutoObservable } from 'mobx';
import { ToastMessage } from 'primereact/toast';

class NotificationStore {
  public notifications: ToastMessage[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  public showNotification = (notification: ToastMessage): void => {
    this.notifications.push(notification);
  };

  public getNotification = (): ToastMessage => this.notifications.pop();
}

const notificationStore = new NotificationStore();
export default notificationStore;
